import { DefaultComparator } from './comparators/default-comparator';
import {
  IFilterComparator,
  FilterOptions,
  FilterPassParams
} from '../filter-types';
import { convertToStringArray } from '../filter-utils';
import { FilterResultFacade } from '../filter-result-facade';
import {
  CalendarGridColumnLabel,
  CalendarGridColumnName
} from '../../../grid/types/column.types';
import { FilterHandlerBase } from './base/filter-handler-base';
import { bqValueGetter } from '../../../grid/utils/value-getters/bank-qualified-getter';

export class BankQualifiedFilterHandler extends FilterHandlerBase {
  private comparator: IFilterComparator<any>;

  get name(): string {
    return CalendarGridColumnName.BankQualified;
  }

  get label(): string {
    return CalendarGridColumnLabel.BankQualified;
  }
  get isInclusiveExclusive(): boolean {
    return false;
  }
  getFilterOptions(filterOptions: FilterOptions): any {
    return convertToStringArray(filterOptions.bankQualified);
  }

  hasValidDiff(options: FilterOptions, grid: any, store: any): boolean {
    return this.getValidDiffComparator(options).hasValidDiff(grid, store);
  }

  getValidDiffComparator(options): IFilterComparator<any> {
    if (!this.comparator) {
      this.comparator = new DefaultComparator();
    }
    this.comparator.applyFilterOptions(this.getFilterOptions(options));
    return this.comparator;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    const isBankQualifiedFilter = params.filters[this.name];
    const { id: dealId, series, isBankQualified } = params.deal;

    const bqValue = bqValueGetter({
      data: {
        series,
        isBankQualified
      }
    });

    const isBankQualifiedFilterPassed =
      isBankQualifiedFilter !== null
        ? bqValue.indexOf(isBankQualifiedFilter.model.value) !== -1
        : true;

    result.applyDealFilerResult(dealId, this.name, isBankQualifiedFilterPassed);

    return isBankQualifiedFilterPassed;
  }
}
